import React from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';
import FullPageScreen, { IFullPageScreenProps } from 'components/full-page-screen';
import Header from 'components/full-page-screen/header';
import Modal, { ModalContent, ModalSize, modalSizeStyles } from 'components/modal';
import { IModalProps } from 'components/modal/types';
import useCartAddOns, { IAddOnSection } from 'hooks/use-cart-add-ons';
import useDialogModal from 'hooks/use-dialog-modal';
import useMediaQuery from 'hooks/use-media-query';
import { routes } from 'utils/routing';

import AddExtrasContent from './add-extras-content';

interface IAddExtrasModalProps extends IBaseProps {
  redirectUrl?: string;
  addOns?: IAddOnSection[];
}

const StyledModal = styled(Modal)`
  ${Styles.desktop`
      min-width: ${(p: IModalProps) => modalSizeStyles.minWidth[p.size!]};
      min-height: ${(p: IModalProps) => modalSizeStyles.minHeight[p.size!]};
  `}
`;

const ContentContainer = styled(ModalContent)`
  & div.modal-scroller {
    padding-top: 0;
  }

  & div.modal-inner {
    margin: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    grid-auto-rows: auto;
    text-align: justify;
  }

  & div.modal-scroller {
    padding-top: calc(${Styles.layout.checkoutHeaderHeight} + env(safe-area-inset-top));
  }
`;

export const ExtrasModalDesktop: React.FC<IFullPageScreenProps> = ({
  onClose,
  heading,
  children,
}) => (
  <StyledModal size={ModalSize.SMALL} allowsDismiss={false}>
    <Box width="100%" flexDirection="column" overflow="hidden">
      <Header heading={heading} onClose={onClose} />
      <ContentContainer>{children}</ContentContainer>
    </Box>
  </StyledModal>
);

const AddExtrasModal: React.FC<IAddExtrasModalProps> = ({
  redirectUrl = routes.cart,
  addOns = [],
}) => {
  const { formatMessage } = useIntl();

  const {
    totalPrice,
    totalQuantity,
    handleAddToCart,
    isEdit,
    addOnSelections,
    updateQuantityForItem,
  } = useCartAddOns({ addOnData: addOns });

  const isDesktop = useMediaQuery('desktop');
  const content = (
    <AddExtrasContent
      addOns={addOns}
      addToCart={handleAddToCart}
      isEdit={isEdit}
      addOnSelections={addOnSelections}
      updateQuantityForitem={updateQuantityForItem}
      totalPrice={totalPrice}
      totalQuantity={totalQuantity}
    />
  );
  const [DialogModal] = useDialogModal<{}, IFullPageScreenProps>({
    Component: ExtrasModalDesktop,
    init: true,
  });

  const ModalComponent = isDesktop ? DialogModal : FullPageScreen;

  return (
    <ModalComponent heading={formatMessage({ id: 'addExtras' })} closeHref={redirectUrl}>
      {content}
    </ModalComponent>
  );
};

export default AddExtrasModal;
